import { Trans, useTranslation } from 'react-i18next';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectSearchPagesList, selectSearchPagesParams } from 'app/store/DMSDocumentPages/DMSDocumentPages.selectors';
// Mui
import { Toolbar, Typography } from '@mui/material';
// Components
import PagesToolbar from 'app/components/PagesToolbar';

const SearchToolbar = () => {
  const { t } = useTranslation();

  // State
  const pages = useAppSelector(selectSearchPagesList);
  const params = useAppSelector(selectSearchPagesParams);

  if ( !pages || !pages.length ) return null;
  return (
    <PagesToolbar toolType="files" pages={pages}>
      <Toolbar sx={{ gap: 4 }}>
        <PagesToolbar.Actions>
          <Typography variant="body2">
            <Trans
              t={t} i18nKey={params.keywords?.length ? 'pages.search.pagesFoundFor' : 'pages.search.pagesFound'}
              components={{ b: <b /> }}
              values={{ pages: pages.length, keywords: params.keywords?.join(', ') }}
            />
          </Typography>
        </PagesToolbar.Actions>
      </Toolbar>
    </PagesToolbar>
  )
}

export default SearchToolbar;
